import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'
import { prop } from 'ramda'
import { Placeholder } from '../../GlobalStyles'

export const BackgroundSectionSecondary = () => {
  const data = useStaticQuery(graphql`
    query {
      BottomImage: file(name: { eq: "c_image" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
    }
  `)
  return prop('BottomImage', data) ? (
    <Image fluid={data.BottomImage.childCloudinaryAsset.fluid} />
  ) : (
    <Placeholder />
  )
}

export default BackgroundSectionSecondary
